import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { withLang } from "./withLang";

export const paypalApi = createApi({
  reducerPath: "paypalApi",
  baseQuery: withLang(
    fetchBaseQuery({
      baseUrl: `${process.env.REACT_APP_API_BASE_URL}/paypal/`,
    }),
  ),
  endpoints: (builder) => ({
    createPaypalTransaction: builder.mutation({
      query: (body) => ({
        url: `create-transaction`,
        method: "POST",
        body: body,
      }),
    }),
    sendSMS: builder.mutation({
      query: (body) => ({
        url: `sendsms`,
        method: "POST",
        body: body,
      }),
    }),
    verifySMS: builder.mutation({
      query: (body) => ({
        url: `verifysms`,
        method: "POST",
        body: body,
      }),
    }),
    connectPaypal: builder.mutation({
      query: (body) => ({
        url: `referral-link`,
        method: "POST",
        body: body,
      }),
    }),
  }),
});

export const {
  useCreatePaypalTransactionMutation,
  useSendSMSMutation,
  useVerifySMSMutation,
  useConnectPaypalMutation,
} = paypalApi;
